/* global yaCounterNUMBERID */

import helpers from '../helpers';
import scrollDepth from 'scroll-depth';

function start15SecTimeout() {
	clearTimeout(helpers.$window.data('timeout15Sec'));

	helpers.$window.data('timeout15Sec', setTimeout(() => {
		ga('rbcspec.send', 'event', 'page', 'spent_on_page_15_sec');
		ga('send', 'event', 'page', 'spent_on_page_15_sec');

		gtag('event', 'spent_on_page_15_sec', {
			event_category: 'page',
		});

		ym(93591439, 'reachGoal', 'spent_on_page_15_sec', {spent_on_page_15_sec: 'true'});
	}, 15000));
}

function clearText(text) {
	return text.toString().trim().replace(/\s+/g, ' ');
}

start15SecTimeout();

scrollDepth({
	userTiming: false,
	pixelDepth: false,
	gtmOverride: true,
	eventHandler(data) {
		ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
		ga('rbcspec.send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});

		gtag('event', 'scroll_depth', {
			event_category: 'page',
			event_label: data.eventLabel,
		});

		ym(93591439, 'reachGoal', 'scroll depth', {
			'scroll depth': {
				percentage: data.eventLabel,
			},
		});
	},
});

/**
* Создать куки запись
* @param {string} path Обязательное, ссылка/путь
*/
function virtualHit(path) {
	if (window.ga) {
		ga('set', 'page', path);
		ga('send', 'pageview', path);
		// Не всегда используются
		ga('rbcspec.set', 'page', path);
		ga('rbcspec.send', 'pageview', path);
	}

	ym(93591439, 'hit', path);

	// NUMBERID нужно менять для каждого проекта, так же используется в PUG
	if (window.yaCounterNUMBERID) {
		yaCounterNUMBERID.hit(path);
	}
}

// logo
$('.header__partner__logo').on('click', () => {
	ga('send', 'event', 'client link', 'logo header');
	ga('rbcspec.send', 'event', 'client link', 'click');

	gtag('event', 'client_link', {
		event_category: 'navigation',
		event_label: 'logo header',
	});

	ym(93591439, 'reachGoal', 'client link', {
		'client link': {
			place: 'logo header',
		},
	});
});

$('.header__rbc').on('click', () => {
	ga('send', 'event', 'nav', 'rbc logo');

	gtag('event', 'rbc_logo_header_click');

	ym(93591439, 'reachGoal', 'rbc_logo_header_click', {rbc_logo_header_click: 'click'});
});

// links
$('.article a:not(.link-more)').on('click', (e) => {
	let link = $(e.currentTarget).attr('href');
	let name = e.currentTarget.innerText;

	if (!link.indexOf('https://elsi-group.ru')) {
		ga('send', 'event', 'client link', 'article text link', name);
		ga('rbcspec.send', 'event', 'client link', 'click');

		gtag('event', 'client_link', {
			event_category: 'article text link',
			event_label: name,
		});

		ym(93591439, 'reachGoal', 'client link', {
			'client link': {
				'article text link': {
					link: name,
				},
			},
		});
	} else {
		ga('send', 'event', 'article', 'article text link', name);

		gtag('event', 'text_link_click', {
			event_category: 'article',
			event_label: name,
		});

		ym(93591439, 'reachGoal', 'text link click', {
			'text link click': {
				article: {
					link: name,
				},
			},
		});
	}
});

$('.article__economy .link-more').on('click', () => {
	ga('send', 'event', 'client link', 'bottom text link');
	ga('rbcspec.send', 'event', 'client link', 'click');

	gtag('event', 'client_link', {
		event_category: 'bottom text link',
	});

	ym(93591439, 'reachGoal', 'client link', {
		'client link': {
			place: 'bottom text link',
		},
	});
});

$('.home__info--articles a.home__info__item').on('click', (e) => {
	const $this = $(e.currentTarget);
	const item = $this.closest('.home__info__item');
	const name = item.find('.home__info__item__title').text();

	ga('send', 'event', 'main', 'see also bottom', name);

	gtag('event', 'see_also_bottom', {
		event_label: name,
	});

	ym(93591439, 'reachGoal', 'see also event', {
		'see also event': {
			'main bottom': {
				name,
			},
		},
	});
});

$('.home__pop-up .link-more.js-goto').on('click', (e) => {
	const thisCard = $(e.currentTarget).closest('.home__pop-up');
	const name = thisCard.find('.home__pop-up__title').text();

	ym(93591439, 'reachGoal', 'project performance click', {
		'project performance click': {
			'card name': name,
		},
	});
});

$('.home__pop-up .link-more:not(.js-goto)').on('click', () => {
	ga('send', 'event', 'main', 'go to article', 'card');

	gtag('event', 'go_to_article', {
		event_label: 'card',
	});

	ym(93591439, 'reachGoal', 'go to article', {
		'go to article': {
			place: 'card',
		},
	});
});

$('.home .read-also a.link-more').on('click', () => {
	ga('send', 'event', 'main', 'go to article', 'footer');

	gtag('event', 'go_to_article', {
		event_label: 'footer',
	});

	ym(93591439, 'reachGoal', 'go to article', {
		'go to article': {
			place: 'footer',
		},
	});
});

$('.article .read-also a.link-more').on('click', (e) => {
	let name = e.currentTarget.offsetParent.querySelector('.read-also__item__text').innerText;

	ga('send', 'event', 'article', 'see also bottom', name);

	gtag('event', 'see_also_bottom', {
		'event_category': 'article',
		'event_label': name,
	});

	ym(93591439, 'reachGoal' ,'see also event', {
		'see also event': {
			'article bottom':{
				'name': name
			}
		}
	});
});

// share
$('.page--article .share__buttons button').on('click', (e) => {
	const name = $(e.currentTarget).data('social');

	ga('send', 'event', 'share', 'article share', name);

	gtag('event', 'share', {
		event_category: 'article',
		event_label: name,
	});

	ym(93591439, 'reachGoal', 'share', {
		share: {
			article: {
				'social-name': name,
			},
		},
	});
});

$('.footer__share button, .page--home .share__buttons button').on('click', (e) => {
	const name = $(e.currentTarget).data('social');

	ga('send', 'event', 'share', 'project share', name);

	gtag('event', 'share', {
		event_category: 'project share',
		event_label: name,
	});

	ym(93591439, 'reachGoal', 'share', {
		share: {
			'project share': {
				'social-name': name,
			},
		},
	});
});

// video
helpers.$document
	.on('video-play', (e, name) => {
		ga('send', 'event', 'video', 'play', name, {nonInteraction: true});
		ga('rbcspec.send', 'event', 'video', 'play', {nonInteraction: true});

		gtag('event', 'video_play', {
			event_label: name,
		});

		ym(93591439, 'reachGoal', 'video play', {
			'video play': {
				'video name': name,
			},
		});

		console.log('video-play');
	})
	.on('video-end', (e, name) => {
		ga('send', 'event', 'video', 'finish', name);
		ga('rbcspec.send', 'event', 'video', 'finish');

		gtag('event', 'video_finish', {
			event_label: name,
		});

		ym(93591439, 'reachGoal', 'video finish', {
			'video finish': {
				'video name': name,
			},
		});
	})
	.on('video-30-sec', (e, name) => {
		ga('send', 'event', 'video', 'timing 30s', name, 30);
		ga('rbcspec.send', 'event', 'video', 'timing 30s', '', 30);

		gtag('event', 'video_30s', {
			event_label: name,
		});

		 ym(93591439, 'reachGoal', 'video 30s', {
			'video 30s': {
				'video name': name,
			},
		});
	});

$('.home__info__item').on('click', function () {
	const $this = $(this);
	const event = $this.closest('.home__info__list').data('parentga');
	const name = $(this).find('.js-card-name').text();

	ga('send', 'event', 'main', event, name);

	if (event === 'news card show') {
		gtag('event', 'news_card_show', {
			event_label: name,
		});

		ym(93591439, 'reachGoal', event, {
			'news card show': {
				'news card name': name,
			},
		});
	} else if (event === 'day rate card show') {
		gtag('event', 'day_rate_card_show', {
			event_label: name,
		});

		ym(93591439, 'reachGoal', 'day rate card show', {
			'day rate card show': {
				'day rate card name': name,
			},
		});
	} else if (event === 'heroes card show') {
		gtag('event', 'heroes_card_show', {
			event_label: name,
		});

		ym(93591439, 'reachGoal', 'heroes card show', {
			'heroes card show': {
				'heroes card name': name,
			},
		});
	}
});

// test
$('.home-goals__start').on('click', () => {
	ga('send', 'event', 'test', 'start', '', {nonInteraction: true});
	ga('send', 'event', 'test', 'start', {nonInteraction: true});

	ym(93591439, 'reachGoal', 'test start', {
		'test start': true,
	});
});

// $('.js-test-step-to-question').on('click', (e) => {
// 	let num = $(e.currentTarget).closest('.js-test-step').data('step');
// 	let name = $(e.currentTarget).closest('.js-test-step').find('.test__question').text();
// 	let obj = {};

// 	name = clearText(name);
// 	obj[num] = name;

// 	ga('send', 'event', 'test', `question show ${num}`, name, {nonInteraction: true});

// 	ym(93591439, 'reachGoal', 'question show', {
// 		'question show': obj,
// 	});

// 	console.log(obj);
// });

// $('.js-test-step-answer-question').on('click', (e) => {
// 	let num = $(e.currentTarget).closest('.js-test-step').data('step');
// 	let name = $(e.currentTarget).closest('.js-test-step').find('.js-test-step-answer:checked + span').text();
// 	let obj = {};

// 	name = clearText(name);
// 	obj[num] = name;

// 	ga('send', 'event', 'test', `question answer ${num}`, name);

// 	ym(93591439, 'reachGoal', 'question answer', {
// 		'question answer': obj,
// 	});

// 	console.log(obj);
// });

$('.js-test-to-main').on('click', () => {
	ga('send', 'event', 'test', 'to mainpage');

	ym(93591439, 'reachGoal', 'to mainpage', {
		'to mainpage': true,
	});
});

export default {
	start15SecTimeout,
	virtualHit,
};
